import './StatusMessage.scss';
import { ReactComponent as LockIcon} from '../../assets/images/lock-icon.svg';
import { ReactComponent as DangerIcon} from '../../assets/images/danger-icon.svg';
import { ReactComponent as BlockIcon} from '../../assets/images/block-icon.svg';
import { classNames } from 'primereact/utils';




const StatusMessage = ({ variant, message }) => {
    return (
        <div className={`status-message variant-${variant}`} style={{visibility: message ? '' : 'hidden'}}>
            <div className="message">
                {variant === 'lock' && <LockIcon className="icon" />}
                {variant === 'danger' && <DangerIcon className="icon" />}
                {variant === 'block' && <BlockIcon className="icon" />}
                <div className="text">
                    {message || ''}
                </div>
            </div>
        </div>
    )
}

export default StatusMessage;